<div class="buttons">
  <div
    class="left button"
    [ngClass]="{ selected: selected === 0 }"
    (click)="setSelected(0)"
    (keypress)="setSelected(0)"
  >
    {{ option1 }}
  </div>
  <div
    class="center button"
    [ngClass]="{ selected: selected === 1, right: isTwo }"
    (click)="setSelected(1)"
    (keypress)="setSelected(1)"
  >
    {{ option2 }}
  </div>
  <div
    *ngIf="!isTwo"
    class="right button"
    [ngClass]="{ selected: selected === 2 }"
    (click)="setSelected(2)"
    (keypress)="setSelected(2)"
  >
    {{ option3 }}
  </div>
</div>
